import * as React from 'react';
import { FC } from 'react';
import { makeStyles, Typography, Tooltip, IconButton } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

interface Props {
    title: string,
    description: string,
    paddingTop: number,
    paddingBottom: number,
    paddingLeft: number
}

const TitleSection: FC<Props> = (props) => {
    const { title, description, paddingBottom, paddingLeft, paddingTop } = props;

    const flex = {
        flex: { display: 'flex' },
        flexColumn: { display: 'flex', flexDirection: 'column' },
        leftCol: { flex: 1, marginRight: '0.5em' },
        rightCol: { flex: 1, marginLeft: '0.5em' },
        singleCol: { marginTop: '1em', marginBottom: '1em' },
    };

    const useStyles = makeStyles(theme => ({
        root: {
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            paddingLeft: paddingLeft
        },
        desc: {
            fontSize: 11,
            marginLeft: -5,
            marginTop: -11,
        }
    }));
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div style={flex.flex}>
                <div>
                    <Typography  gutterBottom>
                        {title}
                    </Typography>
                </div>
                <div>
                    <Tooltip title={description} placement="right-start">
                        <IconButton className={classes.desc}>
                            <HelpIcon style={{ fontSize: 18 }} />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default TitleSection;